<template>
    <div class="popup-loader">
           <div style="padding: 15%;">
             <div class="text-center mt-5">
                    <div class="mb-5">
                      <div style="font-size:18px; font-family: OpenSans-bold; color: #1d71b8;">
                        <span>Cargando</span>
                      </div>
                      <p></p>
                    </div>
                    <div>
                      <img src="../../static/MYFRAC.gif" alt="LogoMyFrac">
                    </div>
              

                </div>
                <slot></slot>
           </div>
        </div>
</template>

<script>
export default {
    name: "Loader",

}
</script>

<style >

.popup-loader {
    z-index: 9999;
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0, .5);
    transition: all .2s;
    opacity: 1;
    visibility: visible;

}

</style>